<template>
<a href="javascript:void(0)" :class="current" :data-scp="scp" @click="goback">
	<i class="icon icon-back"></i>
	<span>返回</span>
</a>
</template>

<script>
export default {
	props: ['current', 'scp']
	, methods: {
		goback: function(){
			location.href = '/index.html';
		}
	}
}
</script>